import { render } from "./TeacherEditContainer.vue?vue&type=template&id=73bcf238&ts=true"
import script from "./TeacherEditContainer.vue?vue&type=script&lang=ts"
export * from "./TeacherEditContainer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__